import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { GithubPicker } from 'react-color'

export const styles = {
  RED: {
    color: 'rgb(184, 0, 0)'
  },
  ORANGE: {
    color: 'rgb(219, 62, 0)'
  },
  YELLOW: {
    color: 'rgb(252, 203, 0)',
  },
  GREEN: {
    color: 'rgb(0, 139, 2)'
  },
  BLUE: {
    color: 'rgb(0, 77, 207)'
  },
  PURPLE: {
    color: 'rgb(160, 50, 193)'
  },
  GREY_1: {
    color: 'rgb(170, 170, 170)'
  },
  GREY_2: {
    color: 'rgb(136, 136, 136)'
  },
  GREY_3: {
    color: 'rgb(102, 102, 102)'
  },
  GREY_4: {
    color: 'rgb(68, 68, 68)'
  },
  GREY_5: {
    color: 'rgb(34, 34, 34)'
  },
  BLACK: {
    color: 'rgb(0, 0, 0)'
  }
}

const colors = Object.keys(styles).map(color => styles[color].color)

function getStyleNameFromRGB({ r, g, b }) {
  const color = `rgb(${r}, ${g}, ${b})`
  const name = Object.keys(styles).find(style => {
    return styles[style].color === color
  })
  if (name === 'BLACK') {
    return
  }
  return name
}

export default class FontColor extends Component {
  static propTypes = {
    toggleStyleGroup: PropTypes.func.isRequired,
    editorState: PropTypes.object.isRequired
  }

  state = {
    open: false
  }

  showColorPicker = event => {
    event.preventDefault()
    this.setState({ open: true })
  }

  handleColorChange = color => {
    this.setState({ open: false }, () => {
      this.props.toggleStyleGroup(styles, getStyleNameFromRGB(color.rgb))
    })
  }

  getCurrentColor() {
    const currentStyle = this.props.editorState.getCurrentInlineStyle()
    const currentColor = Object.keys(styles).find(style => currentStyle.has(style))
    const color = currentColor && styles[currentColor].color || 'black'
    return color
  }

  render() {
    const menuClass = classnames('color-menu', { active: this.state.open })
    return (
      <div className="color-picker" onMouseDown={this.showColorPicker}>
        <div className="control">
          <div>A</div>
          <div style={{borderTop: `3px solid ${this.getCurrentColor()}`}}></div>
        </div>
        <div className={menuClass}>
          <GithubPicker
            width="162px"
            colors={colors}
            onChange={this.handleColorChange} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/controls/font_color.js